import React, { Fragment } from "react";
import ArrowDownward from "@material-ui/icons/ArrowDownward";
import Search from "@material-ui/icons/Search";
import PropTypes from "prop-types";
import styled from "styled-components";

import Loader from "../../../ui/Loader";
import { Category, Name, Row } from "../components";
import { ReportLink } from "./ReportLink";
import CustomParamsReportLink from "./CustomParamsReportLink";
import propTypes from "../../../../constants/propTypes";

const ReportName = styled.div`
  margin-right: 16px;
`;

const LinksWrapper = styled.div`
  margin-bottom: 8px;
`;

const ReportLinks = ({
  projectReport,
  reportsLoader,
  handleDownloadReport,
}) => {
  const {
    hasPdf,
    hasCsv,
    hasXls,
    hasCustomParams,
    ...reportData
  } = projectReport;
  const { templateName } = reportData;

  return (
    <Loader width="150px" height="32px">
      {hasCsv && (
        <ReportLink
          {...reportData}
          label=".CSV"
          Icon={ArrowDownward}
          loading={reportsLoader[`${templateName}-csv-false`]}
          onClick={() => handleDownloadReport(reportData, "csv")}
        />
      )}
      {hasXls && (
        <ReportLink
          {...reportData}
          label=".XLS"
          Icon={ArrowDownward}
          loading={reportsLoader[`${templateName}-xls-false`]}
          onClick={() => handleDownloadReport(reportData, "xls")}
        />
      )}
      {hasPdf && (
        <Fragment>
          <ReportLink
            {...reportData}
            label=".PDF"
            Icon={ArrowDownward}
            loading={reportsLoader[`${templateName}-pdf-false`]}
            onClick={() => handleDownloadReport(reportData, "pdf")}
          />
          <ReportLink
            {...reportData}
            label="Preview"
            Icon={Search}
            loading={reportsLoader[`${templateName}-pdf-true`]}
            onClick={() => handleDownloadReport(reportData, "pdf", true)}
          />
        </Fragment>
      )}
      {hasCustomParams && (
        <CustomParamsReportLink
          projectReport={reportData}
          handleDownloadReport={handleDownloadReport}
          loading={reportsLoader[`${templateName}-xls-false`]}
        />
      )}
    </Loader>
  );
};

ReportLinks.propTypes = {
  projectReport: propTypes.report.isRequired,
  reportsLoader: propTypes.reportsLoader.isRequired,
  handleDownloadReport: PropTypes.func.isRequired,
};

export const ProjectReportRow = ({
  reportsLoader,
  handleDownloadReport,
  projectReport,
}) => {
  const {
    hasPdf,
    hasCsv,
    hasXls,
    isSingle,
    hasCustomParams,
    isUnderConstruction,
    projectReportCategory: { name: categoryName },
    ...reportRest
  } = projectReport;
  const reportWithFlags = {
    hasPdf,
    hasCsv,
    hasXls,
    hasCustomParams,
    ...reportRest,
  };

  return (
    <Row key={`${categoryName}-${reportRest.name}`}>
      <ReportName>
        <Loader width="150px" height="24px">
          <Category>
            {reportRest.name}
            {isUnderConstruction && " 🚧"}
          </Category>
        </Loader>
        <Loader width="100px" height="16px">
          <Name>{!isSingle ? categoryName : ""}</Name>
        </Loader>
      </ReportName>
      <LinksWrapper>
        <ReportLinks
          projectReport={reportWithFlags}
          reportsLoader={reportsLoader}
          handleDownloadReport={handleDownloadReport}
        />
      </LinksWrapper>
    </Row>
  );
};

ProjectReportRow.propTypes = {
  reportsLoader: propTypes.reportsLoader.isRequired,
  handleDownloadReport: PropTypes.func.isRequired,
  projectReport: propTypes.report.isRequired,
};
